export const SET_GLOBAL_DATETIME = 'SET_GLOBAL_DATETIME';
